import React from 'react';
import {
  FaBalanceScale,
  FaArrowDown,
  FaBolt,
  FaChartLine,
  FaProjectDiagram,
  FaRobot,
  FaFlask,
  FaWaveSquare,
} from 'react-icons/fa';
import { botVisualIdentity } from '../botVisualIdentity';

const ICONS = {
  bot: FaRobot,
  breakdown: FaArrowDown,
  classic: FaChartLine,
  crossover: FaProjectDiagram,
  experiment: FaFlask,
  momentum: FaBolt,
  reversion: FaBalanceScale,
  trend: FaWaveSquare,
};

const SIZES = {
  sm: 'h-10 w-10 rounded-xl text-base',
  md: 'h-12 w-12 rounded-2xl text-xl',
  lg: 'h-16 w-16 rounded-2xl text-2xl',
};

const BotAvatar = ({ bot, size = 'md', className = '' }) => {
  const identity = botVisualIdentity(bot);
  const Icon = ICONS[identity.icon] || FaRobot;
  const name = bot?.name || bot?.bot_name || 'Bot';
  return (
    <span
      role="img"
      aria-label={`${name}, ${identity.role}`}
      data-bot-identity={identity.key}
      className={`inline-flex shrink-0 items-center justify-center ring-1 ${SIZES[size] || SIZES.md} ${identity.avatar} ${className}`}
    >
      <Icon aria-hidden="true" />
    </span>
  );
};

export const BotIdentity = ({ bot, size = 'md', compact = false, wrapText = false }) => {
  const identity = botVisualIdentity(bot);
  const name = bot?.name || bot?.bot_name || 'Saved bot';
  const textLayout = wrapText ? 'break-words whitespace-normal' : 'truncate';
  return (
    <div className="flex min-w-0 items-center gap-3" data-bot-identity-group={identity.key}>
      <BotAvatar bot={bot} size={size} />
      <div className="min-w-0">
        <p className={`${compact ? 'text-base' : 'text-lg'} ${textLayout} font-black`}>{name}</p>
        <p className={`${textLayout} text-xs font-bold uppercase tracking-wide text-slate-500 dark:text-slate-400`}>
          {identity.role} · {identity.strategy}
        </p>
      </div>
    </div>
  );
};

export { BotAvatar };
